export const nullFunc = () => {
  return;
};
